import capitalize from '@mui/utils/capitalize';
export default capitalize;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/capitalize.js
// module id = 14
// module chunks = 22